import React from 'react';

import * as Icon from 'react-feather';

export const SidebarData = [

  {
    label: "Main",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Dashboard",
        icon: <Icon.Grid />,
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Admin Dashboard", link: "/" },
          //{ label: "Sales Dashboard", link: "/sales-dashboard" }
        ]
      },
      // {
      //   label: "Application",
      //   icon: <Icon.Smartphone />,
      //   submenu: true,
      //   showSubRoute: false,
      //   submenuItems: [
      //     { label: "Email", link: "/email", showSubRoute: false }

      //   ]
      // }
    ]
  },
  {
    label: "Inventory",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",

    submenuItems: [
      { label: "Products", link: "/product-list", icon: <Icon.Box />, showSubRoute: false, submenu: false },
      

      
      { label: "Category", link: "/category-list", icon: <Icon.Codepen />, showSubRoute: false, submenu: false },

      { label: "Brands", link: "/brand-list", icon: <Icon.Tag />, showSubRoute: false, submenu: false },
      { label: "Units", link: "/units", icon: <Icon.Speaker />, showSubRoute: false, submenu: false },
      { label: "Tax", link: "/tax", icon:<Icon.DollarSign />, showSubRoute: false, submenu: false },
      { label: "Barcode", link: "/print-barcode", icon:<Icon.BarChart />, showSubRoute: false, submenu: false },
      //{ label: "QR Code", link: "/qrcode", icon:<Icon.BarChart />, showSubRoute: false, submenu: false },


    ]
  },
  {
        label: "Purchases",
        submenuOpen: true,
        submenuHdr: "Purchases",
        showSubRoute: false,
        submenuItems: [
          { label: "Purchases", link: "/purchase-list", icon:  <Icon.ShoppingBag />,showSubRoute: false,submenu: false },
          { label: "Purchase Order", link: "/purchase-order-report", icon:  <Icon.FileMinus />,showSubRoute: false ,submenu: false},
          { label: "Purchase Return", link: "/purchase-returns", icon:  <Icon.RefreshCw />,showSubRoute: false,submenu: false },
          { label: "Purchase Invoice", link: "/purchase-order-invoice", icon: <Icon.File />, showSubRoute: false, submenu: false },
        ]
      },
  {
    label: "Stock",
    submenuOpen: true,
    submenuHdr: "Stock",
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      { label: "Manage Stock", link: "/manage-stocks", icon: <Icon.Package />, showSubRoute: false, submenu: false },
      
    ]
  },

  {
    label: "Sales",
    submenuOpen: true,
    submenuHdr: "Sales",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      { label: "Sales", link: "/sales-list", icon: <Icon.ShoppingCart />, showSubRoute: false, submenu: false },
      { label: "Invoices", link: "/sales-invoices", icon: <Icon.FileText />, showSubRoute: false, submenu: false },
      { label: "Sales Return", link: "/sales-returns", icon: <Icon.Copy />, showSubRoute: false, submenu: false },
      { label: "Quotation", link: "/quotation-list", icon: <Icon.Save />, showSubRoute: false, submenu: false },
      

    ]
  },
  {
    label: "Finance & Accounts",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Finance & Accounts",
    submenuItems: [
      {
        label: "Expenses",
        submenu: true,
        showSubRoute: false,
        icon: <Icon.FileText />,
        submenuItems: [
          { label: "Expenses", link: "/expense-list", showSubRoute: false },
          { label: "Expense Category", link: "/expense-category", showSubRoute: false },
          
          
        ],

      },
      { label: "Bank Accounts", link: "/bank-accounts", icon: <Icon.Users />, showSubRoute: false, submenu: false },
      
      { label: "Balance Sheet", link: "/balance-sheet", icon: <Icon.User />, showSubRoute: false, submenu: false },
     
      { label: "Trial Balance", link: "/trial-balance", icon: <Icon.User />, showSubRoute: false, submenu: false },
      
      { label: "Account Statement", link: "/account-statement", icon: <Icon.Users />, showSubRoute: false, submenu: false },
      { label: "Opening Balance", link: "/opening-balance", icon: <Icon.Users />, showSubRoute: false, submenu: false },
      { label: "Opening Balance Entry", link: "/opening-balance-entry", icon: <Icon.Users />, showSubRoute: false, submenu: false },
      
    ]
  },

  {
    label: "People",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "People",

    submenuItems: [
      { label: "Customers", link: "/customers", icon: <Icon.User />, showSubRoute: false, submenu: false },
      { label: "Suppliers", link: "/suppliers", icon: <Icon.Users />, showSubRoute: false, submenu: false },

    ]
  },

  {
    label: "Reports",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Reports",
    submenuItems: [      
      { label: "Sales Report", link: "/sales-report", icon: <Icon.BarChart2 />, showSubRoute: false },
      { label: "Purchase Report", link: "/purchase-report", icon: <Icon.PieChart />, showSubRoute: false },
      { label: "Inventory Report", link: "/inventory-report", icon: <Icon.Inbox />, showSubRoute: false },
      { label: "Invoice Report", link: "/invoice-report", icon: <Icon.File />, showSubRoute: false },
      { label: "Supplier Report", link: "/supplier-report", icon: <Icon.UserCheck />, showSubRoute: false },
      { label: "Customer Report", link: "/customer-report", icon: <Icon.User />, showSubRoute: false },
      { label: "Expense Report", link: "/expense-report", icon: <Icon.FileText />, showSubRoute: false },
      { label: "Income Report", link: "/income-report", icon: <Icon.BarChart />, showSubRoute: false },
      { label: "Tax Report", link: "/tax-report", icon: <Icon.Database />, showSubRoute: false },
      { label: "Profit & Loss", link: "/profit-loss-report", icon: <Icon.TrendingDown />, showSubRoute: false }
    ],
  },


  {
    label: "User Management",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "User Management",
    submenuItems: [
      { label: "Users", link: "/users", icon: <Icon.UserCheck />, showSubRoute: false }
    
    ]
  },
  {
    label: "Pages",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Pages",
    submenuItems: [
      { label: "Profile", link: "/profile", icon: <Icon.User />, showSubRoute: false },
      { label: "Company Settings", link: "/company-settings", icon: <Icon.Settings />, showSubRoute: false },
    ]
  },

  




]
